/**
 * Reusable style constants for the postmark look.
 */

/**
 * Hard offset shadows — never blurred, like ink on paper. Values are Chakra token
 * references ({colors.ink/16} = ink at 16%), expanded when used in a style prop.
 */
export const HARD_SHADOW = {
  button: '3px 3px 0 {colors.ink}',
  buttonHover: '4px 4px 0 {colors.ink}',
  card: '8px 10px 0 {colors.ink/16}',
  /** For filter: follows the stamp's perforated outline instead of its box. */
  stamp: 'drop-shadow(4px 5px 0 {colors.ink/14})',
  phone: 'drop-shadow(10px 14px 0 {colors.ink/20})'
} as const;

/** Background patterns, as token references so Chakra resolves the alpha at runtime. */
export const PAPER_PATTERN = {
  /** Dotted envelope-paper texture. */
  grain: { bgImage: 'radial-gradient({colors.ink/7} 1px, transparent 1.2px)', bgSize: '5px 5px' },
  /** Ruled letter lines every 38px; pair with lineHeight 38px. */
  ruled: { bgImage: 'repeating-linear-gradient(transparent 0 37px, {colors.stamp/18} 37px 38px)' }
} as const;

/** Faint ink rules: dashed card dividers and address lines. */
export const INK_RULE = {
  dashed: '2px dashed {colors.ink/30}',
  line: '1.5px solid {colors.ink/30}'
} as const;

/** Stamp-blue pill with ink border and offset shadow: the primary button. */
export const PILL_BUTTON = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  bg: 'stamp',
  color: 'white',
  fontWeight: '700',
  border: '2px solid',
  borderColor: 'ink',
  borderRadius: 'full',
  boxShadow: HARD_SHADOW.button,
  px: '22px',
  py: '11px',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'transform 0.15s, box-shadow 0.15s',
  _hover: {
    transform: 'translate(-1px, -1px)',
    boxShadow: HARD_SHADOW.buttonHover,
    textDecoration: 'none',
    color: 'white'
  }
} as const;
